import { useRouter } from 'next/router';
import IosShare from '@mui/icons-material/IosShare';
import { useSnackbar } from 'notistack';

interface Props {
  text: string;
  size?: 'small' | 'medium';
  trackClick?: () => void;
}

export const ShareButton = ({
  text,
  size = 'small',
  trackClick,
}: Props) => {
  const router = useRouter();
  const { enqueueSnackbar } = useSnackbar();

  const sharePage = async () => {
    const url = `https://gondola.cc${router.asPath}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: document.title,
          text,
          url,
        });
      } catch (err) {
        // noop
      }
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url);
      enqueueSnackbar('Page copied!', { variant: 'success' });
    }
    if (trackClick) {
      trackClick();
    }
  };

  const buttonClassName = size === 'small' ? 'btn-primary-outlined-xs' : 'btn-primary-outlined';
  return (
    <button
      type="button"
      onClick={sharePage}
      className={`flex items-center ${buttonClassName} uppercase`}
    >
      <IosShare fontSize="small" />
      <span className="ml-2">Share</span>
    </button>
  );
};
